export default __webpack_public_path__ + "static/media/273832150_640207637193578_7044291378121449207_n.5754563b.jpg";